/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	PoliJobsProposalDTO,
	PoliJobsProposalDTOFromJSON,
	PoliJobsProposalDTOFromJSONTyped,
	PoliJobsProposalDTOToJSON,
} from "./PoliJobsProposalDTO";

/**
 *
 * @export
 * @interface PoliJobsProposalDTOPagedResponse
 */
export interface PoliJobsProposalDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof PoliJobsProposalDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof PoliJobsProposalDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof PoliJobsProposalDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<PoliJobsProposalDTO>}
	 * @memberof PoliJobsProposalDTOPagedResponse
	 */
	data?: Array<PoliJobsProposalDTO> | null;
}

export function PoliJobsProposalDTOPagedResponseFromJSON(
	json: any
): PoliJobsProposalDTOPagedResponse {
	return PoliJobsProposalDTOPagedResponseFromJSONTyped(json, false);
}

export function PoliJobsProposalDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PoliJobsProposalDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(PoliJobsProposalDTOFromJSON),
	};
}

export function PoliJobsProposalDTOPagedResponseToJSON(
	value?: PoliJobsProposalDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(PoliJobsProposalDTOToJSON),
	};
}
